import {
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'

interface IProps {
  isOpen: boolean
  onClose: () => void
  url?: string
  fileName?: string
  fileSize?: number
}

export default function PreviewModal({ isOpen, onClose, url, fileName, fileSize }: IProps) {
  const [isAndroid, setIsAndroid] = useState(false)

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor
    setIsAndroid(userAgent.match(/Android/i) ? true : false)
  }, [])

  return url ? (
    <ChakraModal isOpen={isOpen} onClose={onClose} size="6xl" isCentered scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader paddingBottom={0}>
          {fileName || 'Visualização do arquivo'}{' '}
          {fileSize && <small className="text-muted">({(fileSize / 1024 / 1024).toFixed(2)} Mb)</small>}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p={5}>
          {url.endsWith('.pdf') ? (
            <iframe
              src={isAndroid ? `${process.env.REACT_APP_API_URL}pdf.js/web/viewer.html?file=${url}` : url}
              style={{ width: '100%', height: '75vh' }}
            />
          ) : (
            <img src={url} style={{ width: '100%', height: 'auto' }} />
          )}
        </ModalBody>
      </ModalContent>
    </ChakraModal>
  ) : (
    <></>
  )
}
